import { createContext, useContext } from 'react';

type PageConfigComponentMetadataContextType = {
  index: number;
  name?: string;
};

const PageConfigComponentMetadataContext = createContext<PageConfigComponentMetadataContextType | undefined>(undefined);

export const usePageConfigComponentMetadata = () => {
  return useContext(PageConfigComponentMetadataContext);
};

export default PageConfigComponentMetadataContext;
